import * as Sentry from '@sentry/nextjs';
import { Component, ErrorInfo, ReactNode } from 'react';
import { Text } from '../Text';
import { FlexContainer } from '../Container';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <FlexContainer flexDirection="column" gap="sm" padding="lg">
          <Text size="lg" weight="semibold">Something went wrong</Text>
          <Text color="textSecondary">
            Please refresh the page. If the problem persists, contact support.
          </Text>
        </FlexContainer>
      );
    }

    return this.props.children;
  }
}
